<!--
 * @Author: gongzhichao
 * @Date: 2023-05-24 17:14:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 二级页面公共组件 - 移动端
-->
<template>
  <div class="main">
    <Breadcrumb></Breadcrumb>
    <div class="information">
      <div class="content-slot">
        <slot></slot>
      </div>
    </div>
    <Footer ></Footer>
  </div>
</template>

<script>
import Breadcrumb from "../Breadcrumb/Breadcrumb.vue";
import Footer from "../../../../components/mobile/Footer/index.vue";
export default {
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  components: { Breadcrumb, Footer },
};
</script>

<style lang="scss" scoped>
.main {
  width: 375px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("~@/assets/image/pc/basemap-second-content.png") no-repeat;
  background-size: 100% 100%;

  .information {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: auto;
    z-index: 999;
    .content-slot {
      height: calc(100vh - 226px);
      padding: 0 20px 20px 20px;
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}
</style>
